import { Flex } from '@utilitywarehouse/hearth-react';
import { ReactElement } from 'react';

import { BreakdownItem } from '@components/BreakdownItem';

enum Topics {
  unemploymentAndIllnesss = 'unemploymentAndIllnesss',
  personalAccident = 'personalAccident',
}

const createDetailsList = (items: string[]): ReactElement => (
  <Flex direction="column" spacing="md" asChild>
    <ul className="incomeProtector__coverage__breakdown-list">
      {items.map((item) => (
        <BreakdownItem key={item} type="notCovered">
          {item}
        </BreakdownItem>
      ))}
    </ul>
  </Flex>
);

export const topics = [
  {
    id: Topics.unemploymentAndIllnesss,
    title: 'Unemployment & illness cover',
    details: createDetailsList([
      'If your work is temporary, casual, occasional or on a contract basis which does not extend beyond 12 months',
      'Any period for which you have received a payment instead of working a notice period',
      'Unemployment which is notified to you during the 90 day period immediately following the start date of your insurance',
      'No benefits are payable under the injury/illness section of the policy after age 75',
      'Voluntary unemployment or unemployment due to your misconduct',
      'Unemployment which is normal or seasonal in your occupation',
      'Any pre-existing medical condition in the 12 months before the start of cover',
    ]),
  },
  {
    id: Topics.personalAccident,
    title: 'Personal accident cover',
    details: createDetailsList([
      'That results from you engaging in any flying other than as a passenger',
      'Which is caused by gradual loss or use of function',
      'Hospitalisation due to an illness',
    ]),
  },
] as const;
